import React from 'react';

import styled from 'styled-components';

import theme, { ColorNameType } from '../theme';

import Icon from '../Icon';

import { Prediction } from './types';
import { Paragraph } from '../Typography';

export interface PlacesResultProps {
  item: Prediction;
  onClick: () => void;
}

const withoutCountry = (secondaryText: string) =>
  secondaryText.substr(0, secondaryText.lastIndexOf(','));

const PlacesResult: React.FC<PlacesResultProps> = ({ item, onClick }) => {
  if (!item) return null; // To prevent hot reload issues

  const { structured_formatting } = item;
  const { main_text, secondary_text } = structured_formatting;
  return (
    <Container onMouseDown={ev => ev.preventDefault()} onClick={onClick}>
      <MarkerIcon />
      <AddressText>{main_text}</AddressText>
      <CityText>{withoutCountry(secondary_text)}</CityText>
    </Container>
  );
};

export default PlacesResult;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding: 5px 12px;
  &:hover {
    background-color: #f1f1f1;
    cursor: pointer;
  }
`;

const MarkerIcon = styled(Icon).attrs({
  type: 'marker',
  height: 15,
  width: 12,
  color: theme.gray8 as ColorNameType,
})``;

const AddressText = styled(Paragraph)`
  && {
    text-indent: 10px;
    font-size: 14px;
    line-height: 22px;
    color: ${theme.gray8 as ColorNameType};
    margin-bottom: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

const CityText = styled(Paragraph)`
  && {
    text-indent: 4px;
    font-size: 12px;
    line-height: 20px;
    color: ${theme.gray7 as ColorNameType};
    margin-bottom: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-left: auto;
  }
`;
